<template>
   <div>
      <div class=" container-fluid   ">
        <div class="llp-container-section  heightcontainer ">
       <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
      <!-- Start the code for this screen here -->
      <div id="reporting" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
         <div>
            <nav class="navbar navbar-expand-lg  bg-info text-white" v-if ="reportissue === reportIssue"><span><b> Report An Issue</b></span></nav>
            <nav class="navbar navbar-expand-lg  bg-info text-white" v-if ="reportissue === checkstatus"><span><b> Update An Issue</b></span></nav>
            <center><span :style="msgcolor"><b>{{information}}</b></span></center>
            <br>
            <input type="radio" class="ml-3"  v-model="reportissue" v-bind:value="reportIssue" name="radio" checked  @click="resetEntries()"> Report Issue
            <input type="radio" class="ml-3"  v-model="reportissue" v-bind:value="checkstatus" name="radio" @click="resetEntries()"> Check Status
            <br><br>
            <div v-if ="reportissue === reportIssue">
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Report Title</label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <input type ="text" v-validate="'required'" name="Title" data-vv-as="Title" class="form-control input-sm" v-model="report.title" placeholder="Enter Report Title">
                     <div v-if="errors.has('Title')" class="alert-danger" > {{ errors.first('Title') }} </div>
                  </div>
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Severity</label>
                  </div>
                  <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <select v-model="report.severity" v-validate="'required'" name="Severity" class="form-control input-sm" data-vv-as="Severity" >
                        <option  value="" disabled>Select</option>
                        <option v-for="severity in severites">{{severity.name}}</option>
                     </select>
                     <div v-if="errors.has('Severity')" class="alert-danger" > {{ errors.first('Severity') }} </div>
                  </div>
               </div>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label name="Names"   class="col-form-label col-form-label-sm required"> Screen Names</label>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <multiselect
                        style="width:100%"
                        v-validate="'required'"
                        name="screenName"
                        data-vv-as="screenName"
                        v-model="report.screenName"
                        :options="screens"
                        v-bind:value="screens.value"
                        v-bind:key="screens.key"
                        :custom-label="customLabel">
                     </multiselect>
                     <div v-if="errors.has('screenName')" class="alert-danger" > {{ errors.first('screenName') }} </div>
                  </div>
                  <!--<div class="col-20" >
                     <label name="image"  > Select an image</label>
                       </div>
                     <div class="col-20" v-if="!image">
                     <input type="file" @change="onFileChange">
                     </div>
                     <div class="col-20"  v-else>
                     <img :src="image" />
                     <button @click="removeImage" class="btn-blue-save" style="height:58%">Remove image</button>
                     </div>-->
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm">Issue Description</label>
                  </div>
                  <div class="col-12 col-lg-4 col-md-12 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                     <textarea  placeholder="Enter Description" :maxlength="2000" rows="4" class=" form-control input-sm" cols="60" v-model="report.incDesc"></textarea>
                  </div>
               </div>
               <br>
               <center><button  class="btn btn-secondary" @click="savefeedback">Submit</button></center>
            </div>
            <div v-if="reportissue === checkstatus" >
               <div class="row p-2 justify-content-center">
                  <div class="col">
                     <div class="table-responsive table-responsive-sm">
                        <table  class="table table-sm table-bordered table-striped ">
                           <thead>
                              <tr class="table-month-header-blue">
                                 <th v-for="(col,index) in colheaders" :key="index"><span >{{col.header}}</span></th>
                              </tr>
                           </thead>
                           <tr v-for="(report,index) in sortedIssues" :key="index">
                              <td> <input type="radio" v-model="selectedissue" @click="updateReportIssue(index)" name="radio1" v-bind:value="report.siId" > </td>
                              <td class="table-month-td" >{{report.createdAt| moment("MM/DD/YYYY")}}</td>
                              <td class="table-month-td">{{report.title}}</td>
                              <td class="table-month-td">{{report.severity}}</td>
                              <td class="table-month-td">{{report.incDesc}}</td>
                              <td class="table-month-td">{{report.creationUserI}}</td>
                              <td class="table-month-td">{{report.caseStatus}}</td>
                           </tr>
                        </table>
                     </div>
                  </div>
               </div>
               <br><br>
               <div v-if="report.siId!=''">
                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                     <div class="col d-flex justify-content-end align-items-center">
                        <label>Report Title</label>
                     </div>
                     <div class="col  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input type ="text"  v-model="report.title" class="form-control input-sm" placeholder="Enter Report Title" disabled>
                     </div>
                     <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm">Severity</label>
                     </div>
                     <div class="col  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <select v-model="report.severity" class="form-control input-sm" disabled>
                           <option  value="" disabled>Select</option>
                           <option v-for="severity in severites">{{severity.name}}</option>
                        </select>
                     </div>
                  </div>
                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                     <div class="col d-flex justify-content-end align-items-center">
                        <label name="Names" class="col-form-label col-form-label-sm" > Screen Names</label>
                     </div>
                     <div class="col d-flex justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <select v-model="report.screenName" class="form-control input-sm" disabled>
                           <option  value="">Select</option>
                           <option v-for="screenname in screens">{{screenname.value}}</option>
                        </select>
                     </div>
                     <!--<div class="col-20" >
                        <label name="image"  > Select an image</label>
                          </div>
                        <div class="col-20" v-if="!image">
                        <input type="file" @change="onFileChange">
                        </div>
                        <div class="col-20"  v-else>
                        <img :src="image" />
                        <button @click="removeImage" class="btn-blue-save" style="height:58%">Remove image</button>
                        </div>-->
                     <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm">Issue Description</label>
                     </div>
                     <div class="col  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <textarea  placeholder="Enter Description" :maxlength="2000" rows="4" cols="60" v-model="report.incDesc"></textarea>
                     </div>
                  </div>
                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                     <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm required">Issue Status</label>
                     </div>
                     <div class="col  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <select  v-validate="'required'" class="form-control input-sm" data-vv-name="Employee" v-model.trim="report.caseStatus" >
                           <option disabled  :value='null' > Select Status </option>
                           <option selected v-for="status in statuslist" v-bind:value="status.value" v-bind:key="status.key" > {{ status.value}} </option>
                        </select>
                        <div v-if="errors.has('Employee')" class="alert-danger"> {{ errors.first('Employee') }} </div>
                     </div>
                  </div>

               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center mb-5">
                        <div class="col  justify-content-end align-items-center ">
                           <button  class="btn btn-secondary" @click="saveissuedata">Submit</button>
                        </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- End of the code for this screen here -->
      <bottom-footer></bottom-footer>
        </div>
      </div>
   </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpaddtask from '../js/http-addtask'
export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'feedback',
  data () {
    return {
      image: '',
      reportissue: 'reportIssue',
      reportIssue: 'reportIssue',
      checkstatus: 'checkstatus',
      selectedissue: '',
      issuesList: [],
      statuslist: [
        { key: 'Open', value: 'Open' },
        { key: 'In Progress', value: 'In Progress' },
        { key: 'Waiting For Inputs', value: 'Waiting For Inputs' },
        { key: 'Resolved', value: 'Resolved' },
        { key: 'Reopen', value: 'Reopen' },
        { key: 'Closed', value: 'Closed' }
      ],
      colheaders: [
        { header: 'Action' },
        { header: 'Date' },
        { header: 'Title' },
        { header: 'Severity' },
        { header: 'Issue Description' },
        { header: 'Created By' },
        { header: 'Status' }
      ],
      msgcolor: {
        color: 'black'
      },
      information: '',
      severites: [{ name: 'Low' }, { name: 'Medium' }, { name: 'High' }, { name: 'Showstopper' }],

      screens: [
        {
          'key': 'Add Activity',
          'value': 'Add Activity'
        },
        {
          'key': 'Add Application',
          'value': 'Add Application'
        },
        {
          'key': 'Add Custome',
          'value': 'Add Customer'
        },
        {
          'key': 'Add Dealer',
          'value': 'Add Dealer'
        },
        {
          'key': 'Add Employee',
          'value': 'Add Employee'
        },
        {
          'key': 'Add Task',
          'value': 'Add Task'
        },
        {
          'key': 'Assigned Dealers',
          'value': 'Assigned Dealers'
        },
        {
          'key': 'Contact Us',
          'value': 'Contact Us'
        },
        {
          'key': 'Convert App To Deal',
          'value': 'Convert App To Deal'
        },
        {
          'key': 'DMV',
          'value': 'DMV'
        },
        {
          'key': 'Edit Quote',
          'value': 'Edit Quote'
        },
        {
          'key': 'Forgot Password',
          'value': 'Forgot Password'
        },
        {
          'key': 'Generate Quote',
          'value': 'Generate Quote'
        },
        {
          'key': 'Home',
          'value': 'Home'
        },
        {
          'key': 'Intro Page',
          'value': 'Intro Page'
        },
        {
          'key': 'Login',
          'value': 'Login'
        },
        {
          'key': 'Manage Employee',
          'value': 'Manage Employee'
        },
        {
          'key': 'Manage In House',
          'value': 'Manage In House'
        },
        {
          'key': 'Manage Mileage',
          'value': 'Manage Mileage'
        },
        {
          'key': 'New User Request',
          'value': 'New User Request'
        },
        {
          'key': 'Report Issue',
          'value': 'Report Issue'
        },
        {
          'key': 'Request Access',
          'value': 'Request Access'
        },
        {
          'key': 'Review Application',
          'value': 'Review Application'
        },
        {
          'key': 'Schedule Activity',
          'value': 'Schedule Activity'
        },
        {
          'key': 'Search Customer',
          'value': 'Search Customer'
        },
        {
          'key': 'Search Employee',
          'value': 'Search Employee'
        },
        {
          'key': 'Update Dealer',
          'value': 'Update Dealer'
        },
        {
          'key': 'Update Task',
          'value': 'Update Task'
        },
        {
          'key': 'View Activity',
          'value': 'View Activity'
        },
        {
          'key': 'View Salesperson Task Notes',
          'value': 'View Salesperson Task Notes'
        },
        {
          'key': 'View Assignments',
          'value': 'View Assignments'
        },
        {
          'key': 'View Dashboard',
          'value': 'View Dashboard'
        },
        {
          'key': 'Views Deals',
          'value': 'Views Deals'
        },
        {
          'key': 'View Scorecard',
          'value': 'View Scorecard'
        },
        {
          'key': 'View Task',
          'value': 'View Task'
        },
        {
          'key': 'View Update Customer',
          'value': 'View Update Customer'
        },
        {
          'key': 'View Update Dealer',
          'value': 'View Update Dealer'
        },
        {
          'key': 'View Update Employee',
          'value': 'View Update Employee'
        }

      ],
      report: this.reporteddata()

    }
  },

  methods: {
    reporteddata () {
      return {

        image: '',
        caseStatus: '',
        createdAt: '',
        creationUserI: '',
        employeeId: '',
        siId: '',
        incDesc: '',
        lastUpdatedAt: '',
        lastUpdatedUserI: '',
        screenName: '',
        severity: '',
        title: ''
      }
    },
    customLabel (option) {
      return `${option.value}`
    },

    savefeedback: function () {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          let schactivityPayload = {
            'employeeId': this.$session.get('employee_id'),
            'title': this.report.title,
            'severity': this.report.severity,
            'screenName': this.report.screenName.key,
            // "image": this.report.image,
            'incDesc': this.report.incDesc,
            'creationUserI': this.$session.get('user_id'),
            'lastUpdatedUserI': this.$session.get('user_id'),
            'caseStatus': this.report.caseStatus
          }
          httpaddtask.post('/support', schactivityPayload).then(response => {
            var status = response.data
            if (status == 'CREATED') {
              this.information = 'Issue was reported Successfully. Support Team would respond 24 to 48 business hours. If any further questions please contact at apps@atek1.com '
              this.msgcolor.color = 'Blue'
              this.report = this.reporteddata()
              console.log(JSON.stringify(status))
            } else {
              this.msgcolor.color = 'Red'
              this.information = ''
            }
          })
            .catch(e => {
              this.msgcolor.color = 'Red'
              this.information = '' || e.name || e.message
            })
        }
      })
    },

    getreportissues () {
      if (this.$session.get('user_id') != 'vasu@luxuryleasepartners.com') {
        httpaddtask.get('/readIssues/' + parseInt(this.$session.get('employee_id'))).then(response => {
          this.issuesList = response.data
          // console.log(this.issuesList)
        })
      }

      if (this.$session.get('user_id') === 'vasu@luxuryleasepartners.com') {
        httpaddtask.get('/readIssues/').then(response => {
          this.issuesList = response.data
          // console.log(this.issuesList)
        })
      }
    },
    updateReportIssue (index) {
      this.getreportissues()
      this.report = this.issuesList[index]
    },
    saveissuedata () {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          httpaddtask.put('/updateissue/' + this.report.employeeId, this.report).then(response => {
            var status = response.data
            if (status == 'ACCEPTED') {
              this.information = 'Issue Edited  Successfully'
              this.msgcolor.color = 'Blue'
              this.getreportissues()
              this.report = this.reporteddata()
              this.selectedissue = ''
            } else {
              this.msgcolor.color = 'Red'
              this.information = ''
              this.getreportissues()
              this.report = this.reporteddata()
              this.selectedissue = ''
            }
          })
            .catch(e => {
              this.msgcolor.color = 'Red'
              this.information = '' || e.name || e.message
              this.getreportissues()
              this.report = this.reporteddata()
              this.selectedissue = ''
            })
        }
      })
    },

    resetEntries () {
      this.getreportissues()
      this.report = this.reporteddata()
      this.selectedissue = ''
      this.information = ''
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    colorRow: function (siId) {
      if (siId === this.selectedissue) { return 'selected-quote' } else { return 'non-selected-quote' }
   				},

    fetchdata: function () {
      // this.getreportissues()
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      this.createImage(files[0])
    },
    createImage (file) {
      var image = new Image()
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.image = ''
    }
  },

  computed: {
    sortedIssues: function () {
      return this.issuesList.sort((a, b) => { return a.caseStatus > b.caseStatus ? 1 : -1 })
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted: function () {
    this.fetchdata()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>
   .paddingright{
      padding-right:30px!important;
   }
</style>
